import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store/store";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
  RouterProvider,
} from "react-router-dom";
import LoginScreen from "./screens/login-screen/LoginScreen";
import PrivateRoute from "./components/PrivateRoute";
import DashboardScreen from "./screens/dashboard-screen/DashboardScreen";
import ForgetPasswordScreen from "./screens/forget-password-screen/ForgetPasswordScreen";
import SetNewPasswordScreen from "./screens/set-new-password/setNewPasswordScreen";
import ReportsScreen from "./screens/reports-screen/ReportsScreen";
import PatientScreen from "./screens/patient-screen/PatientScreen";
import SettingsScreen from "./screens/settings-screen/SettingsScreen";
import PatientDetailsScreen from "./screens/patient-screen/patient-details/PatientDetailsScreen";
import CreateNewAccount from "./screens/create-account-screen/CreateNewAccount";
import SelfCareVisitFlow from "./screens/patient-screen/visit-flow/SelfCareVisitFlow";
import NurseCareVisitFlow from "./screens/patient-screen//visit-flow/NurseCareVisitFlow";
import PhysicianCareVisitFlow from "./screens/patient-screen//visit-flow/PhysicianCareVisitFlow";
import MentalHealthCareVisitFlow from "./screens/patient-screen/visit-flow/MentalHealthCareVisitFlow";
import ListeningEarCareVisitFlow from "./screens/patient-screen/visit-flow/ListeningEarCareVisitFlow";
import NoRouteFoundScreen from "./screens/no-route-found-screen/NoRouteFoundScreen";
import InventoryManagement from "./screens/inventory-management-screen/InventoryManagement";
import ContactDirectory from "./screens/contact-directory/ContactDirectory";
import NotificationScreen from "./screens/notification-screen/NotificationScreen";
import ChatBox from "./screens/messaging-screen/ChatBox";
import TasksScreen from "./screens/tasks-screen/TasksScreen";
import UnsignedEncounter from "./screens/unsigned-encounter/UnsignedEncounter";
import ApiDocumentation from "./screens/api-doc/ApiDocumentation";
import SuccessPage from "./screens/set-new-password/SuccesPage";
import NavigateEmailSuccessPage from "./screens/set-new-password/NavigateEmailSuccessPage";
import JotForm from "./screens/patient-screen/jot-form/JotForm";
import ViewDischargeForm from "./screens/view-discharge-form/ViewDischargeForm";
import DocumentsScreen from "./screens/documents-screen/DocumentsScreen";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      {/* OUR PUBLIC ROUTES COME HERE  */}
      <Route index element={<Navigate to="/login" />} />
      <Route index={true} path="/login" element={<LoginScreen />} />
      <Route
        path="/view-discharge-form/:visitId/:visitNoteId"
        element={<ViewDischargeForm />}
      />
      <Route path="/api-documentation" element={<ApiDocumentation />} />
      <Route
        index={true}
        path="/create-new-account"
        element={<CreateNewAccount />}
      />
      <Route
        index={true}
        path="/forget-password"
        element={<ForgetPasswordScreen />}
      />
      <Route
        index={true}
        path="/set-new-password"
        element={<SetNewPasswordScreen />}
      />
      <Route path="/success-screen" element={<SuccessPage />} />
      <Route path="/email-check" element={<NavigateEmailSuccessPage />} />

      {/* OUR PRIVATE ROUTES HERE */}
      <Route path="" element={<PrivateRoute />}>
        <Route path="/dashboard" element={<DashboardScreen />} />
        <Route path="/reports" element={<ReportsScreen />} />
        <Route path="/patient" element={<PatientScreen />} />
        <Route path="/patient/:patientId" element={<PatientDetailsScreen />} />
        <Route
          path="/patient/:patientId/view-self-care-visit-note/:visitNoteId"
          element={<SelfCareVisitFlow />}
        />
        <Route
          path="/patient/:patientId/view-nurse-care-visit-note/:visitNoteId"
          element={<NurseCareVisitFlow />}
        />
        <Route
          path="/patient/:patientId/view-physician-care-visit-note/:visitNoteId"
          element={<PhysicianCareVisitFlow />}
        />
        <Route
          path="/patient/:patientId/view-mental-health-care-visit-note/:visitNoteId"
          element={<MentalHealthCareVisitFlow />}
        />
        {/* <Route
          path="/patient/:patientId/view-podiatry-care-visit-note/:visitNoteId"
          element={<PodiatryCareVisitFlow />}
        /> */}
        <Route
          path="/patient/:patientId/view-listening-ear-care-visit-note/:visitNoteId"
          element={<ListeningEarCareVisitFlow />}
        />
        {/* Offsite Transfers — serial notes, no orders/vitals (reuses the
            Listening-Ear-style flow) */}
        <Route
          path="/patient/:patientId/view-offsite-transfers-care-visit-note/:visitNoteId"
          element={<ListeningEarCareVisitFlow />}
        />
        <Route path="/patient/jot-form" element={<JotForm />} />
        <Route path="/settings" element={<SettingsScreen />} />
        <Route path="/unsigned-visits" element={<UnsignedEncounter />} />
        <Route path="/profile" element={<SettingsScreen />} />
        <Route path="/tasks" element={<TasksScreen />} />
        <Route path="/contact-directory" element={<ContactDirectory />} />
        <Route path="/inventory" element={<InventoryManagement />} />
        <Route path="/notifications" element={<NotificationScreen />} />
        <Route path="/messaging" element={<ChatBox />} />
        <Route path="/documents" element={<DocumentsScreen />} />
      </Route>
      <Route path="*" element={<NoRouteFoundScreen />} />
    </Route>
  )
);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
